<!--
 * @Author: your name
 * @Date: 2020-02-18 17:12:51
 * @LastEditTime: 2021-05-28 23:55:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xkxy_front/src/components/Show.vue
 -->
<template>
  <div class="show" :style="`background: url('${require('../assets/bg19.png')}') no-repeat; background-size: 100% 100%;`">
  <!-- <img class="sub-logo" src="../assets/logo4.png"> -->
   <img class="sub-logo6" src="../assets/logo10.png">
    <div class="body">
        <div class="content">
            <div class="video" id="video">
                <div class="player_loading">
                    <div class="load-container load8">
                    <div class="loader"></div></div>
                </div>
            </div>
            <!-- <div class="title">{{ this.info.title }}</div> -->
            <!-- <div class="intro">
             {{ this.info.presenter }}
            </div> -->
               <p class="seeNum">观看量：{{ seeNum }}人</p>
             <div class="video_border"></div>
            <div class="user">
                <div class="title2">
                   <img class="thumb" :src="this.info.user_thumb">
                   <div class="name"> {{ this.info.presenter }}</div>
                </div>
                <div class="intro">
                {{ this.info.intro2 }}
                </div>
            </div>
             <div class="video_border"></div>
            <div class="message"> 
               <div class="leaveMessage">
                    <div><span class="leaveTitle">留言版</span><span>{{ commentNum }}条留言</span></div>
                    <div class="leaveItem" v-for="item in commentList">
                        <div class="leaveName"><div class="sign"></div><div class="name">{{ item.name }}</div></div>
                        <div>{{ item.comment }}</div>
                    </div>
                </div>
                <div class="leavePublic">
                    <div class="input">
                        <van-field
                        v-model="leaveMessage"
                        type="textarea"
                    />
                    </div>
                  <van-row class="bottom" type="flex" justify="center">
                    <van-col ><van-button type="info" class="confirm" @click="submitLeave()">发送</van-button></van-col>
                  </van-row>
                </div>
            </div>
             <div class="video_border"></div>
           
        </div>
    </div>

     <div class="footer"  @click="goback()">
      <img class="goback" src="../assets/goback.png" >
    </div>
    <share></share>
  </div>
</template>
<script>
import { Http } from "@/utils/http.js"
import api from "@/config/api.js"
import Cookies from 'js-cookie'

export default {
  name: 'List',
  data() {
    return {
        player: '',
        vid: '',
        count: 0,
        uid: '',
        info: {},
        seeVideoId: 0, // 观看页面上报更新的id 值
        browseTime: 1, // 页面浏览时长
        updateTime: 5,  // 页面每次上报的间隔
        browseId: 0, // 浏览页面上报更新的id 值
        interval: '', // 轮询计数
        interval2: '', // 轮询计数

        leaveMessage: '', // 留言消息
        repeatClick: false, // 重复提交
        commentList: [],
        commentNum: 0,
         seeNum : 0, // 观看次数
    }
  },

  methods: {
       // 返回上一页
    goback(){
      this.$router.go(-1)
    },
    // 播放视频
    s2j_onVideoPlay() {
      if(this.count == 0){
          this.interval = setInterval(this.upViewTime, 5000)
       }  
      this.count ++;
    },
    // 跟新视频播放时间
    upViewTime(){
       var sec4=this.player.j2s_getCurrentTime();
      //return 
       if(this.vid > 0 && sec4 > 0){
          if(this.count > 0){
              if (this.uid) {
                let data = {}
                data.uid = this.uid
                data.vid = this.vid
                data.see_time = sec4
                data.id = this.seeVideoId
                var that = this
                Http.post(api.updateVideoSee, data).then(response => {
                    if (response.code == 1) {
                        if(that.seeVideoId == 0){
                            //首次观看
                            that.seeVideoId = response.id
                        }
                    } 
                })
            }
              
          }
      }
    },
    fininshVideoJs(){
        console.log('视频js 加载完成')
        const polyvPlayer = window.polyvPlayer;
        this.player = polyvPlayer({
          wrap: '#video',
            'width': '100%',
          'height': '0',
          'vid': this.info.src_id
        });
        setInterval(this.upViewTime(),2000);
    },
    loadScript(src, callback){
        var script = document.createElement('script');
        var head = document.getElementsByTagName('head')[0];
        var loaded;
        script.src = src;
        if (typeof callback === 'function') {
            script.onload = script.onreadystatechange = function () {
            if (!loaded && (!script.readyState || /loaded|complete/.test(script.readyState))) {
                script.onload = script.onreadystatechange = null;
                loaded = true;
                callback();
            }
            }
        }
        head.appendChild(script);
    },
    // 获取视频信息
    getVideoInfo () {
        // 视频数据
        let data = {}
        data.id = this.vid
        Http.post(api.getVideoInfoById, data).then(response => {
            if (response.code == 1) {
                // 写入返回的cookie 值
                this.info = response.data
                document.title = response.data.title
                 this.seeNum = response.num
                // 数据存在则调用视频数据
                if(this.info){
                    this.loadScript('http://player.polyv.net/resp/vod-player/latest/player.js',this.fininshVideoJs)
                }
            } 
        })
    },

    // 统计浏览时长
    updateBrowseTime () {
        // 判断用户id 是否存在
        if (this.uid) {
            let data = {}
            data.uid = this.uid
            data.type = 2 // 视频详细页
            data.type_id = this.vid
            data.see_time = this.browseTime
            data.id = this.browseId
            var that = this
            Http.post(api.browseTime, data).then(response => {
                if (response.code == 1) {
                   if(that.browseId == 0){
                       //首次观看
                       that.browseId = response.id
                   }
                } 
            })
            this.browseTime = this.browseTime + 5
        }
    },
    // 提交留言消息
    submitLeave () {
      if (this.repeatClick) {
        this.customAlert('提交中...')
      }
      this.leaveMessage = this.leaveMessage.trim()
      if (!this.leaveMessage) {
        this.customAlert('评论内容不能空')
        return false
      }
      this.repeatClick = true
      let data = {}
      data.uid = this.uid
      data.vid = this.vid
      data.comment = this.leaveMessage
      Http.post(api.addComment, data).then(response => {
        this.repeatClick = false
        if (response.code == 1) {
          // 写入返回的cookie 值
          this.leaveMessage = ''
          this.customAlert('提交成功,请等待后台审核')
          return 
        } else {
          // 发送失败
          this.customAlert(response.msg)
          return false
        }
      })
    },
    // 获取评论列表 
    getLeaveMessage (){
         // 视频数据
        let data = {}
        data.vid = this.vid
        Http.post(api.getCommentList, data).then(response => {
            if (response.code == 1) {
                // 写入返回的cookie 值
                this.commentList = response.data
                this.commentNum = response.data.length
            } 
        })
    },
     // 弹框
    customAlert (msg) {
      this.$dialog.alert({
        message: msg
      })
    },
  },
  mounted: function() {
    // 获取视频详细
    this.vid = this.$route.query.id
    this.uid = Cookies.get('uid')
    // 跳转到首页
    if(!this.uid){
        this.$router.push({ name: "Index"})
    }
    // 调用视频
    this.getVideoInfo()
    // 跟新页面停留时间
    this.interval2 = setInterval(this.updateBrowseTime, 5000)
    // 将backToday方法绑定到window下面，提供给外部调用
     window['s2j_onVideoPlay'] = () => {
        this.s2j_onVideoPlay()
     }
     // 获取评论列表
     this.getLeaveMessage()
  },
  destroyed() {
    //清除轮询
    clearInterval(this.interval);
    clearInterval(this.interval2);
  }
}
</script>

<style lang="less" scoped>
.show {
     .sub-logo6 {
        position: absolute;
        top: 12px;
        width: 60px;
        right: 8px;
    }
    display: flex;
    min-height: 100vh;
    flex-direction: column;
     .header {
        min-height: 100px;
        img {
            width: 100%;
            display: block;
        }
    }
    .body {
        flex:1;
        padding-left: 30px;
        padding-right: 30px;
        color: #fff;
        .video {
            margin-top: 75px;
            margin-bottom: 12px;
        }
        .title {
            margin-top: 30px;
          //  margin-bottom: 16px;
            font-size: 16px;
        }
        .seeNum {
            font-size: 12px;
            text-align: right;
            color: #171515;
        }
        .user {
          background: #fff;
          color: #1b1515;
          padding: 24px;
          opacity: 0.9;
          border-radius: 24px;
          .title2 {
              font-size: 16px;
              text-align: center;
              .thumb {
                width: 100px;
                height: 100px;
                border: 1px dotted #e6e0e0;
                -webkit-border-radius: 50%;
                border-radius: 50%;
              }
          }
          .intro {
              font-size: 12px;
              white-space: pre-line;
          }
        }
        .video_border {
            border-style:solid;
            border-color: #34afe8;
            width: 80%;
            margin: 0 auto;
        }
         .message {
            font-size: 12px;
             opacity: 0.9;
             .leaveMessage {
                border-top-left-radius: 24px;
                border-top-right-radius: 24px;
                font-size: 12px;
                background: #fff;
                color: #232121;
                padding: 24px;
                max-height: 200px;
                overflow: hidden;
                overflow-y: scroll;
            //   word-break: break-all;
                .leaveTitle {
                    font-size: 16px;
                    padding-right: 24px;
                }
                .leaveItem {
                    overflow-x: hidden;
                    overflow-y: scroll;
                    .leaveName {
                        .sign {
                          width: 12px;
                          background: #34afe8;
                          height: 16px;
                          display: inline-block;
                          margin-left: 12px;
                          margin-right: 12px;
                          float: left;
                        }
                        .name {
                           display: inline-block;
                           line-height: 16px;
                           font-size: 12px;
                           position: relative;
                           text-align: center;
                           float: left;
                           padding-top: 2px;
                        }
                        height: 16px;
                        background-color: #dcd6d6;
                        margin-bottom: 12px;
                        margin-top: 12px;
                    }
                }
            }
            .leavePublic {
                border-bottom-left-radius: 24px;
                border-bottom-right-radius: 24px;
                font-size: 14px;
                background: #fff;
                color: #232121;
                padding: 24px;
                height: 120px;
                .input {
                    border-style: solid;
                    border-width: 1px;
                }
                .confirm {
                  width: 80px;
                  height: 40px;
                  border-radius: 8px;
                  font-size: 16px;
                  border: none;
                  background-color: #3db3ea;
                    margin-top: 20px;
                    margin-bottom: 12px; 
                }
            }
        }
  }

   .footer {
      position: fixed;
      bottom: 0px;
      right: 0;
      .goback {
        background: #b7d0dc;
        border-radius: 40px;
        width: 80px;
      }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Show6.vue